import { z as zod } from 'zod';
import { createErrorMap } from 'zod-validation-error';

const nameFormat = /^[A-Za-zА-Яа-яіІїЇєЄыЫ]+$/;

zod.config({
    customError: createErrorMap(),
});

const CitySchema = zod.object({
    value: zod.number(),
    label: zod.string().min(1),
});

export const PersonalInfoSchema = zod.object({
    name: zod
        .string()
        .min(1, 'validation.required.name')
        .regex(nameFormat, 'validation.onlyLetter'),
    lastName: zod
        .string()
        .min(1, 'validation.required.surName')
        .regex(nameFormat, 'validation.onlyLetter'),
    middleName: zod.string().optional(),
    birthDate: zod.string().min(1),
    gender: zod.string().min(1, 'validation.required.gender'),
    country: zod.string().min(1, 'validation.required.city'),
    city: CitySchema,
});
